import { createContext } from 'react';
import type { ExpertReportModelMode } from '@/entities/expert-report';

/**
 * Режим модели заключения, результат которого показан в карточке диалога.
 *
 * Ссылки на знание в комментариях результата названы одним лишь номером, а нумерация прежней
 * базы знаний и модели знаний идёт независимо, — поэтому режим нужен и там, где показывается
 * знание по ссылке, и там, где знание подставляется в правку комментария. Само заключение
 * читателю карточки диалога закрыто по правам, поэтому режим берётся из его результата.
 *
 * Значение по умолчанию — прежний режим: так же поступает и бэкенд с результатом, режим
 * которого не назван.
 */
export const ExpertReportModelModeContext = createContext<ExpertReportModelMode>('legacy');
